(function (w, d, u, i) {
    var pathname = location.pathname;
    var isUk = pathname.startsWith('/en-uk')

    function getCookie(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    }

    let cookieStore = 'en'

    try {
        var taxDom = document.getElementById("tax_included_text_p");
        if (isUk) {
            taxDom = document.getElementById("tax_included_uk_p");
        }

        if (taxDom) {
            taxDom.classList.add("tax_included_text_p_show");
        }


        const storename = getCookie('storename')
        if (storename) {
            let arr = storename.split("&&&")
            if (Array.isArray(arr)) {
                cookieStore = arr[1]
            }
        }

    } catch (e) {
        console.warn("e", e);
    }

    console.log('cookieStore', cookieStore)

    const tip = {
        en: "Have questions?  Get help from a Hasselblad expert. ",
        fr: "Des questions ? Contactez un expert Hasselblad.",
        de: "Fragen？ Hol dir Hilfe von Hasselblad-Experten."
    }


    w[i] || (w[i] = {});
    w[i].config = {
        lang: "en",
        region: "US",
        appId: "hasselblad",
        appName: "hasselblad",
        appUserId: "hasselblad",
        env: "prod",
        hideTop: true,
        openWindowDirectlyOnMobile: true,
        data: {
            list: [
                {
                    slug: "customer",
                    "support-customer": {
                        icon: "//stormsend1.djicdn.com/stormsend/uploads/ee44d790225791db61bd78e42c1f6295.png",
                        tip: tip[cookieStore] || tip.en,
                        title: "客服服务",
                        showDelay: "10",
                    },
                },
                {
                    slug: "support-echat",
                    echat: {
                        url: "https://fusioncx.lydaas.com/chat-scsp/index.html?instanceId=MTI1ODg%3D&xsp_tenantid=300001001&terminalType=1&preview=1&lang=en_US",
                    },
                },
            ],
        },
        showTips: true,
    };
    var s = d.createElement("script");
    s.setAttribute("defer", "");
    s.setAttribute("crossorigin", "");
    s.setAttribute("src", u);
    (d.body || d.head).appendChild(s);
})(
    window,
    document,
    "https://assets.djicdn.com/pkg/@dji/store-echat@1.9.0/store-echat.umd.js",
    "__EChat__"
);
